import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editdltconf',
  templateUrl: './editdltconf.component.html',
  styleUrls: ['./editdltconf.component.scss']
})
export class EditdltconfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
